import { mount } from 'svelte';
import AuthApp from '@/components/auth/AuthApp.svelte';

const target = document.getElementById('auth-app');

if (target) {
	const pageType = target.dataset.page ?? 'login';
	const inviteToken = target.dataset.inviteToken ?? '';
	const partnerToken = target.dataset.partnerToken ?? '';
	const attributionToken = target.dataset.attributionToken ?? '';
	const csrfToken = target.dataset.csrfToken ?? '';
	const resetToken = target.dataset.resetToken ?? '';
	const inviteAccountName = target.dataset.inviteAccountName ?? '';
	const inviteByName = target.dataset.inviteByName ?? '';
	const inviteEmail = target.dataset.inviteEmail ?? '';
	const returnTo = target.dataset.returnTo ?? '';

	mount(AuthApp, {
		target,
		props: {
			pageType,
			inviteToken,
			partnerToken,
			attributionToken,
			csrfToken,
			resetToken,
			inviteAccountName,
			inviteByName,
			inviteEmail,
			returnTo,
		},
	});
}
